module.exports = __webpack_public_path__ + "img/hero-dropdown-search-chevy.d19e42fa.png";